import { render, staticRenderFns } from "./AddVin.vue?vue&type=template&id=5862bcc3&scoped=true"
import script from "./AddVin.vue?vue&type=script&lang=js"
export * from "./AddVin.vue?vue&type=script&lang=js"
import style0 from "./AddVin.vue?vue&type=style&index=0&id=5862bcc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862bcc3",
  null
  
)

export default component.exports